import React, { Component } from 'react';
import Parse                from 'parse';
import Footer               from './layout/footer';
import InjectTapEventPlugin from "react-tap-event-plugin";
import MuiThemeProvider     from 'material-ui/styles/MuiThemeProvider';

InjectTapEventPlugin();

require('../../sass/app.scss');

Parse.initialize(PARSE_APP_ID, PARSE_CLIENT_ID);
Parse.serverURL = PARSE_SERVER_URL;


export default class App extends Component {

    render() {
        return (
            <MuiThemeProvider>
                <div className="main">
                    {/*{ isGrayNav ? <GrayNavBar/> : <MainNavBar/> } */}
                    {this.props.children}
                    {/*<Footer/>*/}
                </div>
            </MuiThemeProvider>
        );
    }
}



// WEBPACK FOOTER //
// src/components/app.js